/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFolderLock = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M16.167 17v1H15v6h9v-6h-1.167v-1c0-1.796-1.642-3-3.333-3-1.69 0-3.333 1.204-3.333 3zm3.333-1c.887 0 1.333.587 1.333 1v1h-2.666v-1c0-.413.446-1 1.333-1z"
        fill="currentcolor"
      />
      <path
        d="M2 2v20h11v-2H4V4h5.382l2 4H20v4.022c.715.065 1.39.266 2 .578V6h-9.382l-2-4H2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFolderLock as FolderLock };
